import {parseRelativeDateFormula} from 'legacy/modules/common/components/DateRangePicker/util';
import moment from 'moment';

export function parseDate (date) {
  if (!date) {
    return null;
  }
  if (moment(date).isValid()) {
    return moment(date).toDate();
  }
  if (typeof date === 'string') {
    try {
      return parseRelativeDateFormula(date);
    } catch (e) {
      return null;
    }
  }
  return null;
}

export function toUtcString (date) {
  date = parseDate(date);
  return date && moment(date).format('YYYY-MM-DD');
}

export const relativeDateConverters = {
  in: parseDate,
  out (i) {
    if (!i) {
      return null;
    }
    if (typeof i === 'string') {
      return i;
    }
    return moment(i).format('YYYY-MM-DD');
  }
};

export function getDaysLeft (endDate) {
  const now = new Date();
  const end = new Date(endDate);

  const diffTime = end - now;
  const daysLeft = Math.floor(diffTime / (1000 * 60 * 60 * 24));

  return daysLeft;
}
